(function ($, Drupal, once) {
  Drupal.behaviors.menuDropdown = {
    attach: function (context, settings) {
      $(once('d-menu', ".d-menu", context)).each(function() {
        const $menu = $('.menu-item--expanded', context);
        let windowWidth = $(window).width();
        let windowHeight = $(window).height();
        const desktopBreakpoint = 992;

        const $menuNav = $(this);
        const $block = $menuNav.closest('.d-menu-wrapper');
        let submenu = [];
        const isMobileView = () => {
          return windowWidth < desktopBreakpoint;
        }
        const clearMobileMainDropdownState = () => {
          $block.removeClass('is-mobile-main-dropdown-open');
          $menu.find('li.nav-item > ul.dropdown-menu')
            .css('--d-mobile-main-dropdown-max-height', '');
        }
        const setMobileMainDropdownState = ($dropdownMenu) => {
          if (!isMobileView() || !$dropdownMenu.parent().hasClass('nav-item')) {
            return;
          }

          const languageMenu = document.querySelector('.menu--language .dropdown-menu');
          const dropdown = $dropdownMenu.get(0);
          if (!languageMenu || !dropdown) {
            return;
          }

          const languageRect = languageMenu.getBoundingClientRect();
          const dropdownRect = dropdown.getBoundingClientRect();
          const availableHeight = Math.floor(languageRect.top - dropdownRect.top);
          if (availableHeight <= 0) {
            return;
          }

          $block.addClass('is-mobile-main-dropdown-open');
          $dropdownMenu.css('--d-mobile-main-dropdown-max-height', `${availableHeight}px`);
        }
        const resetDeepSubmenu = (item) => {
          item.removeClass('deep-menu');
          item.css('display', 'none');
          item.parent().removeClass('deep-menu');
        }
        const closeDeepSubmenu = (target) => {
          const $parent = target.parent();
          const $grandparent = target.parent().parent();
          if (target.hasClass('nav-link-back')) {
            $grandparent.addClass('slide-right');
            setTimeout(function () {
              resetDeepSubmenu($grandparent);
              $parent.remove();
              $grandparent.removeClass('slide-right');
            }, 500);
          }
        }
        const deepSubmenuCloseIfOpen = () => {
          const deepSubmenu = ($menu.find('a.nav-link-back'));
          if (deepSubmenu.length > 0) {
            deepSubmenu.css('height', 'auto')
            closeDeepSubmenu($(deepSubmenu));
          }
        }
        const dropdownMenuFirstLevelCloseIfOpen = () => {
          const $items = $menu.find('.dropdown-menu').filter(':visible');
          const $siblings = $items.siblings('a');
          $items.css('display', 'none');
          $items.css('height', 'auto');
          $items.css('--d-mobile-main-dropdown-max-height', '');
          $siblings.removeClass('dropdown-open');
          $menu.find('.position-left').removeClass('position-left');
          $menu.find('.position-right').removeClass('position-right');
          clearMobileMainDropdownState();
        }
        const addNavLinkBackToSubmenu = (item) => {
          const $siblingList = item.siblings('ul.dropdown-menu');
          const backLinkText = item.text();

          $siblingList.addClass('deep-menu');
          if ($siblingList.find('.nav-link-back').length === 0) {
            $siblingList.addClass('deep-menu');
            $siblingList.prepend(`<li class="nav-link-back-wrapper"><a class="nav-link-back">${backLinkText}</a></li>`);
          }
          const $deepMenu = $('.deep-menu', context);
          $deepMenu.css('top', '0');
          if (isMobileView()) {
            $deepMenu.css('left', '0');
            const navbarMain = $(document).find('#navbar-main');
            const secondaryMenuRegion = $(document).find('.secondary-menu-region');
            $deepMenu.css('top', (1 * navbarMain.height()));
            $deepMenu.css('height', 'calc(100% - ' + (2 * secondaryMenuRegion.height()) + 'px)');
          }
        }
        const openDeepSubmenu = (target) => {
          const $item = $(target);
          const $parent = $item.parent();
          if (isMobileView()) {
            if ($parent.hasClass('dropdown-item') && $item.siblings('ul').length > 0) {
              addNavLinkBackToSubmenu($item);
              return true;
            }
          }
          return false;
        };
        const removeSubmenuList = (parentOfList) => {
          const $openMenu = parentOfList.find('.submenu-open');
          $openMenu.css('display', 'none');
          parentOfList.find('.submenu-open').removeClass('submenu-open');
          parentOfList.find('.hovered-item').removeClass('hovered-item');
        }

        $menu.on('click', function (event) {
          if (!isMobileView()) {
            return;
          }
          const ev = $(event.target);
          if (ev.is('li.dropdown-item')) {
            event.stopPropagation();
            event.preventDefault();
            ev.children('a').first().trigger('click');
            return;
          }
          const $dropdownMenu = $(this).children('ul.dropdown-menu');
          closeDeepSubmenu(ev);
          const isDeepSubMenuOpen = openDeepSubmenu(event.target);
          if (!ev.parent().parent().hasClass('submenu-open') && !ev.hasClass('nav-link-back')) {
            removeSubmenuList($menu);
          }
          const itemShow = (item) => {
            if (isMobileView()) {
              if (item.children('li').first().hasClass('nav-link-back-wrapper')) {
                item.css('display', 'block');
                item.css({"left": windowWidth}).animate({"left": "0px"}, "slow");
                return;
              }
              item.slideDown();
            }
          }
          const itemHide = (item) => {
            if (isMobileView()) {
              item.slideUp();
            }
          }
          if ($dropdownMenu.length > 0) {
            const target = $(event.target);
            if (!target.closest($dropdownMenu).length && !target.is($dropdownMenu)) {
              event.preventDefault();
              $(document).trigger('d-language-switcher:close');
              const $clickedMenuItem = $(event.target);
              const $clickedMenuItemParent = $clickedMenuItem.parent();
              const $navbarList = $('ul.navbar-nav');
              const $currentMenuDropdown = $navbarList.find('li.dropdown > a.dropdown-open');
              const $menuItemsWithDropdown = $navbarList.find('li.dropdown > a.nav-link');
              if (target.hasClass('nav-link')) {
                $menuItemsWithDropdown.removeClass('dropdown-open');
                $clickedMenuItem.addClass('dropdown-open');
              }
              if (isMobileView() || $clickedMenuItemParent.hasClass('nav-item')) {
                const $clickedItemList = $clickedMenuItem.siblings('ul').first();
                if ($clickedMenuItemParent.is('li') && ($clickedItemList.css('display') === 'block')) {
                  itemHide($clickedMenuItem.siblings('ul'));
                  $clickedMenuItem.removeClass('dropdown-open');
                  clearMobileMainDropdownState();
                  return;
                }
              }
              const $mainItems = $dropdownMenu.parent().parent().find('ul.dropdown-menu').filter(':not(.dropdown-children)');
              const $dropdownChildren = $dropdownMenu.parent().parent().find('ul.dropdown-children');
              itemHide($mainItems);
              itemHide($dropdownChildren);
              itemShow($dropdownMenu);
              setMobileMainDropdownState($dropdownMenu);
              const $childDropdownMenus = $dropdownMenu.find('ul.dropdown-children');
              $childDropdownMenus.each(function (index) {
                const $childDropdownMenu = $(this);
                const positionChildren = function () {
                  const menuItemOffset = $dropdownMenu.parent().offset();
                  removeSubmenuList($menu);
                  if (isMobileView()) {
                    $dropdownMenu.css('left', '');
                    $dropdownMenu.css('position', '');
                    $dropdownMenu.css('top', '');
                    $dropdownMenu.css('height', 'initial');
                  } else {
                    $dropdownMenu.css('position', '');
                    return;
                  }

                  if (!$dropdownMenu.is(':animated')) {
                    $dropdownMenu.css('top', menuItemOffset.top + $dropdownMenu.parent().outerHeight() - $(window).scrollTop());
                  }

                  const parentOffset = $dropdownMenu.offset();
                  const parentWidth = $dropdownMenu.outerWidth();
                  const childWidth = $dropdownMenu.outerWidth();

                  // Position relative to the parent ul.dropdown-menu.
                  const top = parentOffset.top - $(window).scrollTop();
                  const left = $dropdownMenu.hasClass('position-left')
                    ? parentOffset.left - childWidth
                    : parentOffset.left + parentWidth;

                  // Handle collision with screen edge.
                  const viewportWidth = $(window).width();
                  const viewportRight = $(window).scrollLeft() + viewportWidth;

                  if (!$dropdownMenu.is(':animated') && !$childDropdownMenu.is(':animated')) {
                    if (top < 0) {
                      $dropdownMenu.css('height', 'auto');
                      const chevron = $menu.find('.dropdown-open');
                      chevron.removeClass('dropdown-open');
                    } else {
                      $childDropdownMenu.css('top', top);
                    }
                  }
                  if (isMobileView()) {
                    $childDropdownMenu.css('height', '100%');
                  }
                };
                // Initial positioning.
                positionChildren();

                // Adjust position on window resize or scroll.
                $(window).on('resize scroll', function () {
                  positionChildren();
                });
              });

              if (!isDeepSubMenuOpen && (!$(event.target).parent().parent().hasClass('nav-item'))) {
                deepSubmenuCloseIfOpen();
              }
            }
          }
        });

        const setSubmenuPosition = ($item) => {
          const maxHeight = 500;
          let $submenu = $item.data('submenu') ?? [];
          if ($submenu.length === 0) {
            return;
          }
          let rect = $item.get(0).getBoundingClientRect();
          let parentRect = $item.closest('ul').get(0).getBoundingClientRect();
          let submenuRect = $submenu.get(0).getBoundingClientRect();
          let props = {};
          let height = Math.min($(window).height() - submenuRect.top - 16, maxHeight);
          props['max-height'] = height;

          if ($item.hasClass('dropdown-item')) {
            props.top = rect.top - Drupal.displace().top;
            props.left = parentRect.right;

            if ($submenu.outerWidth() + parentRect.right > $(window).width()) {
              $submenu.data('menu-position', 'left');
              props.left = parentRect.left - $submenu.outerWidth();
            }
            else if (($item.closest('.dropdown-items').data('menu-position') ?? 'right') === 'left') {
              $submenu.data('menu-position', 'left');
              props.left = parentRect.left - $submenu.outerWidth();
            }
            else {
              $submenu.data('menu-position', 'right');
            }
          }
          else {
            props.top = 'calc(100% + 8px)';
            props.left = rect.left + (rect.width / 2) - ($submenu.outerWidth() / 2);

            if ($item.hasClass('menu-extended')) {
              delete props['max-height'];
              $submenu.children('.dropdown-menu').css('max-height', height - 8);
              $submenu.next('.submenu').children('.dropdown-menu').css('max-height', height - 8);
            }
          }
          $submenu.css(props);
          if (!$item.hasClass('nav-item')) {
            let firsItemRect = $item.data('submenu').find('li').first().get(0).getBoundingClientRect();
            props.top -= firsItemRect.top - rect.top;
            $submenu.css(props);
          }
        }
        const closeSubMenu = ($item) => {
          $item.each(function() {
            let $item_sibling = $(this);
            $item_sibling.removeClass('open');
            if (isMobileView()) {
              return;
            }
            let $submenu = $item_sibling.data('submenu') || [];
            if ($submenu.length === 0 || ($submenu.length && !$submenu.parent().hasClass('absolute-menu'))) {
              return;
            }

            $submenu.unwrap('.dropdown-overflow-wrapper');
            $submenu.prop('style', '').data('parent').append($submenu);

            closeSubMenu($submenu.find('.open'));
          });
        }
        const closeAllSubmenu = () => {
          $('html').css('overflow-y', '');
          $('body').css('overflow-y', '').css('position', '');

          // Exclude language switcher dropdown from style reset
          $('.dropdown-menu', $menuNav).not('.menu--language .dropdown-menu').css({'height': '', 'display': '', 'position': '', 'top': '', 'left': '', 'max-height': '', 'min-height': ''});
          $('.dropdown-menu', $menuNav).not('.menu--language .dropdown-menu').css('--d-mobile-main-dropdown-max-height', '');
          $('.nav-item.open .nav-link', $menuNav).removeClass('open').trigger('click');
          $('.dropdown-items, .dropdown-overflow, li', $menuNav).not('.menu--language *').css({'display': '', 'transform': ''});
          $('.open, .show, .active-list', $menuNav).not('.menu--language, .menu--language *').removeClass('open show active-list');
          clearMobileMainDropdownState();
        }
        const closeMenuDropdowns = () => {
          if (isMobileView()) {
            deepSubmenuCloseIfOpen();
            dropdownMenuFirstLevelCloseIfOpen();
            $menu.find('.dropdown-children').css('display', 'none');
            $menu.find('.dropdown-open').removeClass('dropdown-open');
            return;
          }

          closeAllSubmenu();
        }

        $(window).on('resize', function () {
          windowWidth = $(window).width();
          windowHeight = $(window).height();
          if (isMobileView()) {
            deepSubmenuCloseIfOpen();
            dropdownMenuFirstLevelCloseIfOpen();
            closeAllSubmenu();
            $menuNav.find('.d-menu-parent-item').remove();
            $menuNav.find('.dropdown-items').children().unwrap();
          }
          else {
            closeAllSubmenu();
            if (!$menuNav.find('.dropdown-items').length) {
              $menuNav.find('.dropdown-menu').wrap('<div class="dropdown-items"></div>');
            }
          }
        })
          .on('sticky:detach', closeAllSubmenu)
          .on('sticky:attach sticky:destroy', function () {
            setSubmenuPosition($menuNav.find('.nav-item.dropdown.open'));
            submenu.forEach(function($submenu) {
              setSubmenuPosition($submenu.find('.dropdown-item.open'));
            });
          });
        $(document, context).on('click', function (event) {
          const $target = $(event.target);
          if (isMobileView()) {
            if ((!$target.closest($menu).length && !$target.is($menu)) || $target.is('ul.dropdown-menu')) {
              // Exclude language switcher dropdown from auto-closing
              const dropdowns = $menu.find('.dropdown-menu').not('.menu--language .dropdown-menu');
              dropdowns.css('display', 'none');
              dropdowns.css('height', 'auto');
              dropdowns.css('--d-mobile-main-dropdown-max-height', '');
              $menu.find('.dropdown-children').css('display', 'none');
              const chevron = $menu.find('.dropdown-open');
              chevron.removeClass('dropdown-open');
              clearMobileMainDropdownState();
            }
          } else if ((!$target.closest($block).length && !$target.is($block))) {
            closeAllSubmenu();
          }
        });
        $(document).on('d-menu:close', closeMenuDropdowns);
        $menuNav.closest('#navbar-nav').on('hidden.bs.collapse', closeMenuDropdowns);
        if (!isMobileView()) {
          $menuNav.find('.dropdown-menu').wrap('<div class="dropdown-items"></div>');
        }

        $menu.each(function () {
          const $item = $(this);
          if (!$item.hasClass('nav-item')) {
            $item.data('parent_item', $item.closest('.nav-item'));
          }
          $item.data('submenu', $item.children('.dropdown-items').data('parent', $item));
        });
        $block.on('mouseleave', function(event) {
          if (isMobileView()) {
            return;
          }
          if (!$(event.relatedTarget).closest('.d-menu-wrapper').is($block)) {
            $menuNav.find('.menu-standard .open').removeClass('open').trigger('d-menu-toggle');
            submenu.forEach(function($submenu) {
              $submenu.removeClass('absolute-menu');
              const $items = $submenu.children('.dropdown-items');
              $items.prop('style', '');
              if (typeof  $items.data('parent') === 'undefined') {
                $items.unwrap('.dropdown-overflow-wrapper');
                return;
              }
              $items.data('parent').append($submenu);
              $items.unwrap('.dropdown-overflow-wrapper');
            });
            submenu = [];
          }
        });
        $('.nav-item.dropdown .nav-link', $menuNav).on('click', function(event) {
          if (isMobileView()) {
            return;
          }
          event.preventDefault();
          $(document).trigger('d-language-switcher:close');
          $menuNav.find('.nav-item.open').not($(this).closest('.nav-item')).removeClass('open').trigger('d-menu-toggle');
          if ($(this).closest('.nav-item').hasClass('menu-extended')) {
            $(this).closest('.nav-item').toggleClass('open').trigger('d-menu-toggle');
            $(this).siblings('.dropdown-overflow-wrapper').find('.menu-depth-1.dropdown').first().trigger('click');
          } else {
            $(this).closest('.nav-item').toggleClass('open').trigger('d-menu-toggle');
            let $submenu = $(this).parent().data('submenu');
            $submenu.data('menu-position', 'right');
            let rect = $submenu.get(0).getBoundingClientRect();
            let windowWidth = $(window).width();
            if (windowWidth <= rect.right && $(this).closest('.nav-item').hasClass('open')) {
              $submenu.css('right', 0);
            } else {
              $submenu.css('right', '');
            }
          }
        });
        $('.nav-item.dropdown', $menuNav).on('d-menu-toggle', function(event) {
          if (isMobileView()) {
            return;
          }
          const $item = $(this);
          if (!$item.hasClass('open')) {
            const $wrapper = $item.children('.dropdown-overflow-wrapper');
            if ($item.hasClass('menu-extended') && $wrapper.length) {
              $item.find('.menu-depth-1.open').removeClass('open').trigger('d-menu-item-toggle');
              $wrapper.children().unwrap();
            }
            else {
              let $submenu = $item.data('submenu');
              $submenu.unwrap();
              $submenu.data('parent').append($submenu);
              $submenu.prop('style', '');
              closeSubMenu($submenu.find('.open'));
            }
            return;
          }
          const $list = $item.children('.dropdown-items');
          if ($list.length) {
            $list.wrap('<div class="dropdown-overflow-wrapper"></div>');
          }
          if ($item.hasClass('menu-extended')) {
            setSubmenuPosition($item);
            return;
          }
          const $submenu = $item.children('.dropdown-overflow-wrapper');
          $submenu.addClass('absolute-menu');
          $submenu.css('left', '0');
          $block.append($submenu);
          setSubmenuPosition($item);
        });
        $('.menu-extended .menu-depth-1', $menuNav).on('click', function(event) {
          if ($(this).hasClass('open') || isMobileView()) {
            return;
          }
          if (!$(this).hasClass('dropdown')) {
            $('a', this).get().click();
            return;
          }
          event.preventDefault();
          $(this).closest('.dropdown-items').find('.menu-depth-1.open').not(this).removeClass('open').trigger('d-menu-item-toggle');
          $(this).addClass('open').trigger('d-menu-item-toggle');

          $('html').css('overflow-y', 'hidden');
          $('body').css('overflow-y', 'scroll');
        }).on('d-menu-item-toggle', function(event) {
          if (isMobileView()) {
            return;
          }
          const $item = $(this);
          const $wrapper = $item.closest('.dropdown-overflow-wrapper');
          if (!$item.hasClass('open')) {
            const submenu = $wrapper.children('.submenu').removeClass('submenu');
            submenu.find('.show-submenu').removeClass('show-submenu');
            submenu.find('.submenu-open').removeClass('submenu-open');
            $item.append(submenu);
            return;
          }
          const submenu = $item.children('.dropdown-items');
          submenu.addClass('submenu');
          $wrapper.append(submenu);
        });
        $menu.on('click', '.dropdown-items.submenu .dropdown',function(event) {
          // Click to expand submenu

          if (isMobileView()) {
            return;
          }

          let $li = $(event.target).is('li') ? $(event.target) : $(event.target).parent('li');
          if ($li.length && !$li.hasClass('dropdown')) {
            return;
          }
          event.preventDefault();
          $(this).parent().addClass('show-submenu');
          $(this).siblings('.dropdown.show-submenu').removeClass('show-submenu');
          const $list = $(this).children('.dropdown-items').children();
          if (!$list.children('.d-menu-parent-item').length) {
            const title = $(this).children('a').first().text();
            $list.prepend(`<li class="d-menu-parent-item">${title}</li>`);
          }
          $(this).siblings('.submenu-open').removeClass('submenu-open');
          $(this).addClass('submenu-open');
          $(this).children('.dropdown-items').css('top', $(this).parent().scrollTop() + 'px');
        }).on('click', '.d-menu-parent-item', function(event) {
          // Click to close submenu

          if (isMobileView()) {
            return;
          }
          event.preventDefault();
          event.stopPropagation();
          const $item = $(this);
          const $parent = $item.closest('.show-submenu');
          $parent.removeClass('show-submenu');
        });
        $('.nav-item.menu-standard .dropdown-item', $menuNav).not('.menu--language .nav-item').on('mouseenter', function(event) {
          if (isMobileView()) {
            return;
          }
          event.preventDefault();
          let $item = $(this);
          closeSubMenu($item.siblings('.open'));

          if (!$item.hasClass('dropdown')) {
            return;
          }

          $item.addClass('open');
          let $submenu = $item.children('.dropdown-items');
          if ($submenu.length === 0) {
            return;
          }
          if ($item.find('.menu-depth-1').length) {
            $submenu.data('menu-position', 'right');
          }
          $submenu.wrap('<div class="dropdown-overflow-wrapper absolute-menu"></div>');
          $item.closest('.dropdown-items').off('scroll').on('scroll', function(event) {
            setSubmenuPosition($item);
            submenu.forEach(function($submenu) {
              setSubmenuPosition($submenu.find('.dropdown-item.open'));
            });
          });
          submenu.push($submenu.parent());
          $block.append($submenu.parent());
          setSubmenuPosition($item);
        }).on('click', function(event) {
          if (isMobileView()) {
            return;
          }
          let $item = $(this);
          if (!$item.hasClass('dropdown') && !$item.hasClass('dropdown-parent-item')) {
            $('.a:visible', $item).first().get(0).click();
            return;
          }
          event.preventDefault();
        });
      });
    }
  };
})(jQuery, Drupal, once);
